<template>
    <v-container>
        <v-card-title>
            Order confirmations
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="orders.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
                v-on:update:pagination="ordenar"
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.item.vat }}</td>
                <td class="text-xs">{{ props.item.concept }}</td>
                <td class="text-xs">{{ props.item.confirmed | confirmed }}</td>
                <td class="text-xs">{{ props.item.status.name }}</td>
                <td class="layout px-0 align-center">
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                            left
                    >
                        <v-btn
                                slot="activator"
                                color="primary"
                                dark
                                fab
                                flat
                        >
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile>
                                <v-btn flat block @click="confirmation(props.item.id)">
                                    <v-icon v-if="props.item.confirmed == 'true'" color="red">check_circle</v-icon>
                                    <v-icon v-if="props.item.confirmed == 'false'" color="primary">check_circle</v-icon>
                                    Confirmation
                                </v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block @click="editStatus = true, newStatus = props.item.status.id"><v-icon left>border_color</v-icon>Edit status</v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block :to="{ name: 'admin.orders.detail', params : { id : props.item.id }, query: { model: 'tab-documents' } }"><v-icon left>description</v-icon>Documents</v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block :to="{ name: 'admin.orders.detail', params : { id : props.item.id }, query: { model: 'tab-info' } }"><v-icon left>shopping_cart</v-icon>Products</v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <v-btn flat block :to="{ name: 'admin.orders.detail', params : { id : props.item.id } }"><v-icon left>remove_red_eye</v-icon>Details</v-btn>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                    <v-dialog v-model="editStatus" persistent max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">Change status</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12 sm12>
                                            <v-autocomplete
                                                    :items="statuses"
                                                    label="Order statutes"
                                                    item-text="name"
                                                    item-value="id"
                                                    v-model="newStatus"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click.native="changeStatusOrder(props.item.id)">Change status</v-btn>
                                <v-btn color="red" @click.native="editStatus = false">Cancel</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="orders.data">
            <v-pagination
                    @input="setPage"
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
            ></v-pagination>
            <p class="subtitle">Showing {{ orders.meta.from }} to {{ orders.meta.to }} of {{ orders.meta.total }} entries</p>
        </div>
    </v-container>
</template>

<script>
    export default {
        props: ['id'],
        data () {
            return {
                dialog: false,
                orders: [],
                search: '',
                headers: [
                    {
                        text: 'VAT',
                        align: 'left',
                        sortable: true,
                        value: 'vat'
                    },
                    { text: 'Concept', value: 'concept' },
                    { text: 'Confirmed', value: 'confirmed' },
                    { text: 'Status', value: 'status_id' },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                direction: 'left',
                statuses: null,
                editStatus: false,
                newStatus: null,
                sortBy: 'vat',
                order: 'asc',
            }
        },
        created () {
            this.getOrders();
            this.getOrderStatuses();
            this.debouncedGetOrders = _.debounce(this.getOrders, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetOrders();
            },
            last_page: function () {
                if (this.page > this.orders.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            ordenar (payload) {
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getOrders();
            },
            setPage (page) {
                  this.page = page;
                  this.getOrders();
            },
            getOrders () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        sortBy: this.sortBy,
                        order: this.order
                    },
                    id: this.id
                };

                this.$store.dispatch('getOrdersClient', params).then((res) => {

                    this.orders = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            deleteOrder () {
                this.$store.dispatch('getOrdersClient', params).then((res) => {

                }).catch((error) => {

                });
            },
            confirmation (id) {
                this.$store.dispatch('orderConfirmation', {
                    id: id
                }).then((res) => {
                    this.getOrders();
                }).catch((error) => {

                });
            },
            getOrderStatuses () {
                this.$store.dispatch('getStatusOrders').then((res) => {
                    this.statuses = res.data.data;
                }).catch((error) => {

                });
            },
            changeStatusOrder(id) {
                this.$store.dispatch('updateStatusOrders', {
                    id: id,
                    status: this.newStatus
                }).then((res) => {
                    this.$store.dispatch('setSnackBarText', {
                        text: 'Status change successfully.'
                    });
                    this.$store.dispatch('activeSnack')
                    this.getOrders();
                    this.newStatus = null;
                    this.editStatus = false;
                }).catch((error) => {

                });
            }
        },
        filters: {
            confirmed: function (value) {
                if (value == 'true') return 'si';
                if (value == 'false') return 'no';
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/clients/view/OrdersComponent.vue